
class featuredPosts extends HTMLElement {
    constructor() {
      super();  
    
      const tag = this.dataset.tag;
      const sectionId = this.dataset.sectionId;
      const blogUrl = this.dataset.blog;
      console.log('featuredPosts TAG', tag, sectionId, blogUrl);


      if(tag) {
        const requestUrl = `${blogUrl}/tagged/${tag}?section_id=${sectionId}`
        console.log(requestUrl, 'requested url');
      fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        //console.log(responseText, 'RESPONSE TEXT');
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        console.log(html, 'html');
        const newHtml = html.querySelector('featured-posts');
        this.innerHTML = newHtml.innerHTML;
    
      }).then(() => {
        this.querySelectorAll('.bd-article-card').forEach((card) => {
            card.classList.add('active');
            card.querySelector('.loading__spinner').classList.add('hidden');
        });
      })
       
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });

      } else {
        this.querySelectorAll('.bd-article-card').forEach((card) => {
          card.classList.add('active');
          card.querySelector('.loading__spinner').classList.add('hidden');
      });
      }


    }
   
     
  }
  
  customElements.define('featured-posts', featuredPosts);